<div class="container vh-100 d-flex justify-content-center align-items-center">
    <div *ngIf="!enteredNumber && !enteredOTP" class="card py-4 px-4">
        <div class="text-center">
        <h3> Login/Sign Up</h3>
        </div>
        <div class="text-center mt-3">
            
        <span class="info-text">Enter your Mobile Number for OTP </span>
        
        </div>
        <div class="position-relative mt-3 form-input">
            <input class="form-control">
            <i class='bx bxs-phone'></i>
        </div>
        
        
        <!-- <div class=" mt-5 d-flex justify-content-between align-items-center">
           
            <button class="go-button">Sign Up</button>
        </div> -->
        <div class="mt-5 row">
            <div class="col text-center">
              <button class="go-button" (click)="EnterPhoneNumber()">Continue</button>
            </div>
          </div>
    </div>
    <div *ngIf="enteredNumber && !enteredAddress" class="card py-4 px-4">
        <div class="text-center">
        <h3> Enter OTP</h3>
        </div>
        <!-- <div class="text-center mt-3">
            
        <span class="info-text">Enter your Mobile Number for OTP </span>
        
        </div> -->
        <div class="position-relative mt-3 form-input">
            <input class="form-control">
            <i class='bx bxs-phone'></i>
        </div>
        
        
        <!-- <div class=" mt-5 d-flex justify-content-between align-items-center">
           
            <button class="go-button">Sign Up</button>
        </div> -->
        <div class="mt-5 row">
            <div class="col text-center">
              <button class="go-button" (click)="EnterOTP()">Continue</button>
            </div>
          </div>
    </div>
    <!-- <div class="container py-5" *ngIf="!enteredNumber && enteredOTP ">
        <div class="row d-flex justify-content-center align-items-center">
          <div class="col">
            <div class="card my-4 shadow-3">
              <div class="row g-0">
                <div class="col-xl-6 d-xl-block bg-image">
                  <img src="https://mdbcdn.b-cdn.net/img/Others/extended-example/delivery.webp" alt="Sample photo"
                    class="img-fluid" />
                  <div class="mask" style="background-color: rgba(0, 0, 0, 0.6)">
                    <div class=" justify-content-center align-items-center h-100">
                      <div class=" text-center" style="margin-top: 220px;">
                        <i class="fas fa-truck text-white fa-3x"></i>
                      
                        <p class="text-white mb-0"></p>
      
                        <figure class="text-center mb-0">
                          <blockquote class="blockquote text-white">
                            <p class="pb-3">
                              <i class="fas fa-quote-left fa-xs text-primary"
                                style="color: hsl(210, 100%, 50%) ;"></i>
                              <span class="lead font-italic">Everything at your doorstep.</span>
                              <i class="fas fa-quote-right fa-xs text-primary"
                                style="color: hsl(210, 100%, 50%) ;"></i>
                            </p>
                          </blockquote>
      
                        </figure>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-6">
                  <div class="card-body p-md-5 text-black">
                    <h3 class="mb-4 text-uppercase">Delivery Info</h3>
      
                    <div class="row">
                      <div class="col-md-6 mb-4">
                        <div data-mdb-input-init class="form-outline">
                          <input type="text" id="form3Example1m" class="form-control form-control-lg" />
                          <label class="form-label" for="form3Example1m">First name</label>
                        </div>
                      </div>
                      <div class="col-md-6 mb-4">
                        <div data-mdb-input-init class="form-outline">
                          <input type="text" id="form3Example1n" class="form-control form-control-lg" />
                          <label class="form-label" for="form3Example1n">Last name</label>
                        </div>
                      </div>
                    </div>
      
                    <div data-mdb-input-init class="form-outline mb-4">
                      <input type="text" id="form3Example8" class="form-control form-control-lg" />
                      <label class="form-label" for="form3Example8">Address</label>
                    </div>
      
      
      
                    <div class="row">
                      <div class="col-md-6 mb-4">
      
                        <select data-mdb-select-init>
                          <option value="1">State</option>
                          <option value="2">Option 1</option>
                          <option value="3">Option 2</option>
                          <option value="4">Option 3</option>
                        </select>
      
                      </div>
                      <div class="col-md-6 mb-4">
      
                        <select data-mdb-select-init>
                          <option value="1">City</option>
                          <option value="2">Option 1</option>
                          <option value="3">Option 2</option>
                          <option value="4">Option 3</option>
                        </select>
      
                      </div>
                    </div>
      
                    <div data-mdb-input-init class="form-outline mb-4">
                      <input type="text" id="form3Example3" class="form-control form-control-lg" />
                      <label class="form-label" for="form3Example3">Zip</label>
                    </div>
      
                    <div data-mdb-input-init class="form-outline mb-4">
                      <input type="text" id="form3Example2" class="form-control form-control-lg" />
                      <label class="form-label" for="form3Example2">Email</label>
                    </div>
      
                    <div class="d-flex justify-content-end pt-3">
                      <button  type="button" data-mdb-button-init data-mdb-ripple-init class="btn btn-success btn-lg ms-2"
                        style="background-color:hsl(210, 100%, 50%) ">Place order</button>
                    </div>
      
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div *ngIf="!enteredNumber && enteredOTP ">
        <div class="row">
            <div class="col-md-8 mb-4">
              <div class="card mb-4">
                <div class="AddressHeadingDiv">
                  <h5 class="mb-0">Add Address Details</h5>
                </div>
                <div class="card-body">
                  <form>
                    <!-- 2 column grid layout with text inputs for the first and last names -->
                    <div class="row mb-4">
                      
                        <div data-mdb-input-init class="form-outline">
                            <label class="form-label" for="form7Example1">Name</label>
                          <input type="text" id="form7Example1" class="form-control" />
                         
                        </div>
                     
                      <!-- <div class="col">
                        <div data-mdb-input-init class="form-outline">
                          <input type="text" id="form7Example2" class="form-control" />
                          <label class="form-label" for="form7Example2">Last name</label>
                        </div>
                      </div> -->
                    </div>
          
                    <!-- Text input -->
                    <div data-mdb-input-init class="form-outline mb-4">
                        <label class="form-label" for="form7Example3">Flat No</label>
                      <input type="text" id="form7Example3" class="form-control" />
                     
                    </div>
          
                    <!-- Text input -->
                    <div data-mdb-input-init class="form-outline mb-4">
                        <label class="form-label" for="form7Example4">Area/Locality</label>
                      <input type="text" id="form7Example4" class="form-control" />
                    
                    </div>
          
                    <!-- Email input -->
                    <div data-mdb-input-init class="form-outline mb-4">
                        <label class="form-label" for="form7Example5">State</label>
                      <input type="email" id="form7Example5" class="form-control" />
                   
                    </div>
          
                    <!-- Number input -->
                    <div data-mdb-input-init class="form-outline mb-4">
                        <label class="form-label" for="form7Example6">Zip Code</label>
                      <input type="number" id="form7Example6" class="form-control" />
                    
                    </div>
          
                  
          
                    <!-- Checkbox -->
               
                        <div class="col text-center">
                          <button class="go-button" >Submit</button>
                        </div>
                     
                  </form>
                </div>
              </div>
            </div>
          
         
          </div>
    </div>
</div>